// Utilities
import { make } from 'vuex-pathify'

let image = 0
const categories = [
  'Все',
  'Love-story',
  'Индивидуальные',
  'Свадебные',
  'Семейные',
]

function GetPictures () {
  let pictures = []

  const family = Array.from({ length: 15 }).map(() => {
    image++
    return {
      srcThumb: `images/photos/family/thumb_${image}.jpg`,
      srcOrigin: `images/photos/family/800_${image}.jpg`,
      category: 'Семейные',
    }
  })
  pictures = pictures.concat(family)
  image = 0
  const individual = Array.from({ length: 46 }).map(() => {
    image++
    return {
      srcThumb: `images/photos/individual/thumb_${image}.jpg`,
      srcOrigin: `images/photos/individual/800_${image}.jpg`,
      category: 'Индивидуальные',
    }
  })
  pictures = pictures.concat(individual)
  image = 0
  const lovestory = Array.from({ length: 37 }).map(() => {
    image++
    return {
      srcThumb: `images/photos/lovestory/thumb_${image}.jpg`,
      srcOrigin: `images/photos/lovestory/800_${image}.jpg`,
      category: 'Love-story',
    }
  })
  pictures = pictures.concat(lovestory)
  image = 0
  const wedding = Array.from({ length: 35 }).map(() => {
    image++
    return {
      srcThumb: `images/photos/wedding/thumb_${image}.jpg`,
      srcOrigin: `images/photos/wedding/800_${image}.jpg`,
      category: 'Свадебные',
    }
  })
  pictures = pictures.concat(wedding)
  image = 0

  let result = []

  const getRandomInt = (max) => Math.floor(Math.random() * Math.floor(max))

  while (result.length !== pictures.length) {
    const index = getRandomInt(pictures.length)
    result.push(pictures[index])
    result = result.filter((v, i, arr) => arr.indexOf(v) === i)
  }

  return result
}

const state = {
  categories,
  filter: 'Все',
  picture: 0,
  pictures: GetPictures(),
  pagPictures: GetPictures(),
}

const mutations = make.mutations(state)

export default {
  namespaced: true,
  state,
  mutations,
}
